import React from 'react'

import CertificateButton from 'components/Certificade'

import {
  Card,
  DateText,
  Grid,
  Meta,
  IssuedBadge,
  Title,
  Training,
} from './styled'

function formatDate(value) {
  if (!value) return 'Date unavailable'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? 'Date unavailable' : date.toLocaleDateString()
}

export default function CertificateLibrary({ certificates = [] }) {
  return (
    <Grid>
      {certificates.map(certificate => (
        <Card key={certificate.documentId || certificate.id}>
          <Meta><span>Certificate</span><IssuedBadge>Issued</IssuedBadge></Meta>
          <Title>{certificate?.certificate_data?.certificateTitle || certificate?.certificate_data?.courseName || 'Course Certificate'}</Title>
          <Training>{certificate?.certificate_data?.trainingName || certificate?.course_module?.title || certificate?.course?.title || ''}</Training>
          <DateText>Issued {formatDate(certificate?.issued_at)}</DateText>
          <CertificateButton
            model={certificate?.certificate_data?.model || 1}
            data={certificate?.certificate_data || {}}
            fileName={`${certificate?.certificate_data?.certificateTitle || certificate?.certificate_data?.courseName || 'certificate'}.pdf`}
            label="Download PDF"
            buttonColor="blue"
          />
        </Card>
      ))}
    </Grid>
  )
}
